var REGEX = /\/:([0-9A-Za-z-_]+)/g;
export default (function (url, params) {
  var matchIterator = url.matchAll(REGEX);
  var paramsCopy = params && JSON.parse(JSON.stringify(params));
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = matchIterator[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var match = _step.value;
      var paramName = match[1];

      if (paramsCopy && paramsCopy[paramName]) {
        url = url.replace(':' + paramName, paramsCopy && paramsCopy[paramName]);
        delete paramsCopy[paramName];
      } else {
        url = url.replace('/:' + paramName, '');
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {
    url: url,
    params: paramsCopy
  };
});